import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import CatalogGrid from '../components/CatalogGrid';
import SellerShopCard from '../components/SellerShopCard';
import { useSellerShop } from '../hooks/useSellerShops';
import { useCatalog } from '../hooks/useCatalog';

function ShopCatalog({ id }) {
  const catalog = useCatalog(id);
  const [params, setParams] = useSearchParams();
  const search = params.get('search') || '';
  const submit = event => {
    event.preventDefault();
    const value = new FormData(event.currentTarget).get('search').trim();
    setParams(value ? { search: value } : {});
  };
  return <>
    <div className="seller-shop-catalog-header">
      <h2>Товары магазина <small>{catalog.total}</small></h2>
      <form onSubmit={submit} className="seller-shop-search">
        <input key={search} type="search" name="search" defaultValue={search} maxLength={100} aria-label="Поиск по магазину" placeholder="Найти в магазине" />
        <button className="btn btn-outline">Найти</button>
      </form>
    </div>
    {catalog.isLoading ? <p role="status">Загружаем товары…</p> : catalog.isError ? <div className="buyer-notice" role="alert">Не удалось загрузить товары. <button type="button" className="btn btn-outline" onClick={() => catalog.refetch()}>Повторить</button></div> : catalog.products.length ? <CatalogGrid {...catalog} /> : <p className="buyer-notice">{search ? 'По этому запросу ничего не найдено.' : 'У магазина пока нет товаров в наличии.'}</p>}
  </>;
}

export default function SellerShopPage() {
  const { id } = useParams();
  const query = useSellerShop(id);
  const valid = /^[1-9]\d*$/.test(id || '') && Number(id) <= 2147483647;
  if (!valid || query.error?.response?.status === 404) return <section className="buyer-empty"><h1>Магазин не найден</h1><Link to="/">Открыть каталог</Link></section>;
  if (query.isError) return <section className="buyer-empty"><h1>Не удалось открыть магазин</h1><button type="button" className="btn btn-primary" onClick={() => query.refetch()}>Повторить</button></section>;
  if (!query.data) return <section className="buyer-page"><p role="status">Открываем магазин…</p></section>;
  return <section className="buyer-page seller-shop-page">
    <Link to="/" className="back-link">← Весь каталог</Link>
    <SellerShopCard sellerId={id} storefront />
    <ShopCatalog id={id} key={id} />
  </section>;
}
